module.exports = __webpack_public_path__ + "img/1.3c1a9431.jpg";